<template>
  <div
    :class="_.grid"
    :style="{
      '--img-height': theme.iconHeight
        ? $transformPx(theme.iconHeight)
        : $transformPx(100),
    }"
  >
    <img
      v-if="theme.layout === '单一布局'"
      :src="data[0].icon"
      :class="_.one"
      @click="$dmbcResourceClick(data[0])"
    />
    <div v-else-if="theme.layout === '左右布局'" :class="_.two">
      <img
        v-track="{
          name: '图片宫格-项目',
          id: `${componentId}-item`,
          resource: data[0],
          index: 0,
        }"
        :src="data[0].icon"
        :class="_.item"
        @click="$dmbcResourceClick(data[0])"
      />
      <img
        v-track="{
          name: '图片宫格-项目',
          id: `${componentId}-item`,
          resource: data[1],
          index: 1,
        }"
        :src="data[1].icon"
        :class="_.item"
        @click="$dmbcResourceClick(data[1])"
      />
    </div>
    <div v-else-if="theme.layout === '靠左布局'" :class="_.threeLeftBig">
      <div :class="_.left">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[0],
            index: 0,
          }"
          :src="data[0].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[0])"
        />
      </div>
      <div :class="_.right">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[1],
            index: 1,
          }"
          :src="data[1].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[1])"
        />
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[2],
            index: 2,
          }"
          :src="data[2].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[2])"
        />
      </div>
    </div>
    <div v-else-if="theme.layout === '靠右布局'" :class="_.threeRightBig">
      <div :class="_.left">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[0],
            index: 0,
          }"
          :src="data[0].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[0])"
        />
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[1],
            index: 1,
          }"
          :src="data[1].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[1])"
        />
      </div>
      <div :class="_.right">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[2],
            index: 2,
          }"
          :src="data[2].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[2])"
        />
      </div>
    </div>
    <div v-else-if="theme.layout === '分散布局'" :class="_.four">
      <div :class="_.left">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[0],
            index: 0,
          }"
          :src="data[0].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[0])"
        />
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[1],
            index: 1,
          }"
          :src="data[1].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[1])"
        />
      </div>
      <div :class="_.right">
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[2],
            index: 2,
          }"
          :src="data[2].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[2])"
        />
        <img
          v-track="{
            name: '图片宫格-项目',
            id: `${componentId}-item`,
            resource: data[3],
            index: 3,
          }"
          :src="data[3].icon"
          :class="_.item"
          @click="$dmbcResourceClick(data[3])"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({})
</script>

<style lang="scss" module="_">
  .grid {
    border-radius: var(--border-radius);
    overflow: hidden;
    font-size: 0;

    img {
      object-fit: cover;
    }

    .one {
      width: 100%;
      height: 120px;
    }

    .two {
      display: flex;

      .item {
        flex: 1;
        height: var(--img-height);
      }
    }

    .threeLeftBig {
      display: flex;

      .left {
        flex: 1;

        .item {
          width: 100%;
          height: 203px;
        }
      }

      .right {
        flex: 1;

        .item {
          width: 100%;
          height: 100px;
        }
      }
    }

    .threeRightBig {
      display: flex;

      .left {
        flex: 1;

        .item {
          width: 100%;
          height: 100px;
        }
      }

      .right {
        flex: 1;

        .item {
          width: 100%;
          height: 203px;
        }
      }
    }

    .four {
      display: flex;

      .left {
        flex: 1;

        .item {
          width: 100%;
          height: 100px;
        }
      }

      .right {
        flex: 1;

        .item {
          width: 100%;
          height: 100px;
        }
      }
    }
  }
</style>
